module.exports = "/assets/a99ed68f9cdaade851f4f92dd8745a48.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/W7.png
// module id = 1950
// module chunks = 0